module.exports = __webpack_public_path__ + "img/laminate_five.a95b7120.png";